export default {
  parentUserList: '/authorize-service/authorize/service/user/parentUserList',
  schoolUserList: '/authorize-service/authorize/service/user/schoolUserList',
  schoolAdminUser: '/authorize-service/authorize/service/user/schoolAdminUser',
  boundWeChat: '/authorize-service/authorize/service/user/boundWeChat',
  modifyPassword: '/authorize-service/authorize/service/user/modifyPassword',
  listSchoolUserResp: '/authorize-service/authorize/service/user/listSchoolUserResp',
  getUserByUserId: '/upms-service/user/user/userId/',
  selectUserByPage: '/authorize-service/authorize/service/user/list',
  userByPhone: '/authorize-service/authorize/service/user/userByPhone',
  batchQueryUser: '/authorize-service/authorize/service/user/batchQueryUser',
  batchQueryUserByUserType: '/authorize-service/authorize/service/user/batchQueryUserByUserType',
  editUserRelation: '/authorize-service/authorize/service/userRelation/editUserRelation',
  updateCurrentRole: '/authorize-service/authorize/service/userRelation/updateCurrentRole',
  findUserRole: '/authorize-service/authorize/service/userRelation/findUserRole',
  queryUserCurrentRole: '/authorize-service/authorize/service/userRelation/queryUserCurrentRole'
}



// WEBPACK FOOTER //
// ./src/config/authority/user/index.js